module.exports = __webpack_public_path__ + "static/media/p2-tip-box-open.a80a4eec.svg";